import { TABLE_PARAMETERS, resolveTableParams } from './resolveTableParams'

export const hierarchicalGridVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard hierarchical grid with depth-banded rows, pagination, and sortable columns.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  flat: {
    code: 'flat',
    displayName: 'Flat',
    description: 'Clean grid with minimal borders. Depth levels use subtle background shading only.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  glass: {
    code: 'glass',
    displayName: 'Glass',
    description: 'Translucent frosted-glass grid with rounded corners and shadow. Best on colored backgrounds.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  legacy: {
    code: 'legacy',
    displayName: 'Legacy',
    description: 'Classic grid with full cell borders and darker depth progression.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  }
}
